import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'

/**
 * Toda troca de tela começa do topo.
 *
 * Quem rola no WP_ONE é o `.ui-shell__main` (o shell é `height: 100dvh;
 * overflow: hidden`), não o documento. Por isso nada reposicionava a tela
 * sozinho: a restauração de rolagem do navegador só age no documento, e o
 * React Router não mexe em container nenhum. Ao navegar dentro do mesmo
 * módulo o shell não desmonta, então o `scrollTop` do main ficava onde
 * estava — voltar do detalhe de um evento caía no meio da lista (achado da
 * Karol em 03/11/2026, em "Eventos principais" e "Últimos eventos").
 *
 * Três decisões, e cada uma evita um estrago:
 *
 * - **Só no `pathname`.** Os filtros, as abas e os modais guardam estado na
 *   query (`?tipo=`, `?dia=`) — reagir à busca inteira jogaria a pessoa pro
 *   topo a cada clique num filtro, no meio da lista que ela está lendo.
 * - **Âncora manda mais.** Com `#secao` na URL o destino é o elemento, não o
 *   topo; aí este efeito sai do caminho.
 * - **Vale no "voltar".** É o caso que motivou o conserto: a Karol quer o
 *   topo também ao voltar, não a posição de antes.
 */
export function RolarParaOTopo() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    // Pode haver mais de um shell montado durante a troca de módulo (o antigo
    // saindo, o novo entrando): zera todos, não só o primeiro.
    for (const main of document.querySelectorAll<HTMLElement>('.ui-shell__main')) {
      main.scrollTop = 0
    }
    // Páginas sem shell (login, páginas públicas) rolam no documento.
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}

/** Casca do roteador: o reposicionamento vale para os cinco módulos de uma vez. */
export function Casca() {
  return (
    <>
      <RolarParaOTopo />
      <Outlet />
    </>
  )
}
